export default __webpack_public_path__ + "static/media/img_background_slide_four.1f55b1da.png";